export const getAuthLink = provider =>
    `${process.env.REACT_APP_BACKEND_URL}/api/oauth2/authorize/${provider}?redirect_uri=${window.location.origin}/oauth2/redirect`
